<template>
  <v-row>
      <v-col cols="2">
        <div class="language-title">
          {{ `${title || 'Regler-Sprache'}` }}
        </div>
      </v-col>
      <v-col>
        <v-select
        v-model="language"
        :items="languages"
        ></v-select>
      </v-col>
  </v-row>
</template>

<script>
export default {
  props: [
    'bridge',
    'languages',
    'title',
    'localStoragePrefix',
  ],

  data: () => ({
    language: 0,
  }),

  watch: {
    language() {
      if (this.bridge) {
        this.bridge.setMenuLanguage(this.language);
      }
      if (this.localStoragePrefix) {
        const languageLsKey = `${this.localStoragePrefix}${this.title ? this.title.replace(' ', '_') : ''}Language`;
        localStorage.setItem(languageLsKey, this.language);
      }
    },
  },

  mounted() {
    if (this.localStoragePrefix) {
      const languageLsKey = `${this.localStoragePrefix}${this.title ? this.title.replace(' ', '_') : ''}Language`;
      const lsValue = localStorage.getItem(languageLsKey);
      if (lsValue != null) {
        this.language = +lsValue;
      }
    }
  }
};
</script>

<style>
.language-title {
  padding-top: 20px;
}
</style>
